/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagDto } from '../../models/tag-dto';
import { UpdateTagDto } from '../../models/update-tag-dto';

export interface TagControllerUpdate$Params {
  id: string;
      body: UpdateTagDto
}

export function tagControllerUpdate(http: HttpClient, rootUrl: string, params: TagControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
  const rb = new RequestBuilder(rootUrl, tagControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagDto>;
    })
  );
}

tagControllerUpdate.PATH = '/api/tags/{id}';
